module.exports = __webpack_public_path__ + "img/folha-de-s-paulo.699e56de.svg";